var SMSplitViewMixin = {
  
  navigationTableHeight: function() {
    
    var $footer = $('#js-dashboard-footer'),
        $navigationTable = $(this.refs.navigationTable);
        
    return(
      $(window).outerHeight() 
      - $navigationTable.offset().top
      - $footer.outerHeight()
    );
  },
  
  mainTableHeight: function() {
    
    var $header = $('#js-dashboard-header-navigation'),
        $footer = $('#js-dashboard-footer');
        
    return(
      $(window).outerHeight() 
      - $header.offset().top 
      - $header.outerHeight() 
      - $footer.outerHeight()
    );
  },
  
  mainTableFooterSizeToFit: function() {
    var $container = $(this.refs.formContent),
        $message = $(this.refs.formMessage);
    $message.
      css({top: $container.offset().top}).
      width($container.outerWidth());
  }
  
};
export default SMSplitViewMixin;



// WEBPACK FOOTER //
// ./app/javascript/components/mixins/SMSplitViewMixin.js